import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  UserGroupIcon,
  WifiIcon,
  ChartBarIcon,
  UserIcon
} from '@heroicons/react/24/outline';
import {
  HomeIcon as HomeIconSolid,
  UserGroupIcon as UserGroupIconSolid,
  WifiIcon as WifiIconSolid,
  ChartBarIcon as ChartBarIconSolid,
  UserIcon as UserIconSolid
} from '@heroicons/react/24/solid';

const MobileBottomNav: React.FC = () => {
  const location = useLocation();

  const navItems = [
    {
      name: 'Dashboard',
      path: '/dashboard',
      icon: HomeIcon,
      iconActive: HomeIconSolid
    },
    {
      name: 'Friends',
      path: '/friends',
      icon: UserGroupIcon,
      iconActive: UserGroupIconSolid
    },
    {
      name: 'Connect',
      path: '/connections',
      icon: WifiIcon,
      iconActive: WifiIconSolid
    },
    {
      name: 'Usage',
      path: '/usage',
      icon: ChartBarIcon,
      iconActive: ChartBarIconSolid
    },
    {
      name: 'Profile',
      path: '/profile',
      icon: UserIcon,
      iconActive: UserIconSolid
    }
  ];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="grid grid-cols-5 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = isActive ? item.iconActive : item.icon;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center transition-colors ${
                isActive
                  ? 'text-primary-600'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon className="h-6 w-6" />
              <span className="text-xs mt-1">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
